import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import { FinancialGridRow, Category } from '@features/ocr/types/types';

interface DeleteConfirmationDialogProps {
  open: boolean;
  rowToDelete: FinancialGridRow | null;
  categories: Category[];
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  rowToDelete,
  categories,
  onConfirm,
  onCancel
}) => {
  if (!rowToDelete) return null;

  const categoryName = categories.find((c) => c.id === rowToDelete?.originalCategoryId)?.name || 'Unknown Category';

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-confirm-title"
      aria-describedby="delete-confirm-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 'sm',
        },
      }}
    >
      <DialogTitle id="delete-confirm-title">Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-confirm-description">
          Are you sure you want to delete the item "{rowToDelete?.itemName}" for category "{categoryName}"? This action needs
          to be saved to become permanent.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;